var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTowardGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.524 12.6599C24.1587 12.0184 24.1587 10.9765 23.524 10.335L13.7759 0.481144C13.1413 -0.160381 12.1106 -0.160381 11.476 0.481144C10.8413 1.12267 10.8413 2.16451 11.476 2.80604L20.0766 11.5L11.4811 20.194C10.8464 20.8355 10.8464 21.8773 11.4811 22.5189C12.1157 23.1604 13.1464 23.1604 13.781 22.5189L23.5291 12.665L23.524 12.6599Z",
    fill: "url(#paint0_linear_9470_41608)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.524 12.6599C13.1587 12.0184 13.1587 10.9765 12.524 10.335L2.77592 0.481144C2.14128 -0.160381 1.11062 -0.160381 0.475982 0.481144C-0.15866 1.12267 -0.15866 2.16451 0.475982 2.80604L9.07665 11.5L0.481059 20.194C-0.153583 20.8355 -0.153583 21.8773 0.481059 22.5189C1.1157 23.1604 2.14636 23.1604 2.781 22.5189L12.5291 12.665L12.524 12.6599Z",
    fill: "url(#paint1_linear_9470_41608)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9470_41608",
    x1: 24,
    y1: 10.7333,
    x2: 11,
    y2: 10.7333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9470_41608",
    x1: 13,
    y1: 10.7333,
    x2: -8.01765e-9,
    y2: 10.7333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowardGradient);
export default __webpack_public_path__ + "static/media/toward-gradient.fbd77593a728f01667d7dd401c744dbe.svg";
export { ForwardRef as ReactComponent };